import { useDependencies } from '@servicetitan/react-ioc';
import { FinancingApi, Provider } from '@servicetitan/financing-api-client';
import { useQuery } from '@tanstack/react-query';

export interface EnabledProvidersOptions {
    tenantId: string;
}

export const useEnabledProviders = (options: EnabledProvidersOptions) => {
    const { tenantId } = options;
    const [apiClient] = useDependencies(FinancingApi);

    const settingsResult = useQuery({
        queryKey: ['tenantsProviderPreferences', tenantId],
        queryFn: () => apiClient.tenantsGetAllProviderPreferences(tenantId),
        enabled: !!tenantId, // Only run query if tenantId exists
    });

    const enabledProviders =
        settingsResult.data?.data
            ?.filter(p => p.enabled)
            .sort((a, b) => (a.preferred ? -1 : b.preferred ? 1 : 0))
            .map(
                p =>
                    `${p.providerName?.charAt(0).toLowerCase()}${p.providerName?.slice(1)}` as Provider,
            ) ?? [];

    return {
        enabledProviders,
        isLoading: settingsResult.isLoading,
    };
};
